import ProductsHeader from '@propertypal/web-ui/src/headers/products/ProductsHeader';
import DevelopersContent from '@propertypal/web-ui/src/products/DevelopersContent';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Developers Products - PropertyPal',
  description:
    'View Our Range Of Agent And Developer Products And Solutions To Help Enhance Your Brand And Get Your Listings Seen By More People.',
  url: `/products/developers`,
};

const DevelopsProducts = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <ProductsHeader />
      <DevelopersContent />
      <ProductsContact reason="Developers Products & Services" />
    </>
  );
};

export default DevelopsProducts;
